try {

    //window.bootstrap = require('bootstrap');

    require('bootstrap/js/dist/carousel');
    require('bootstrap/js/dist/collapse');
    require('bootstrap/js/dist/tab');

    window.Modal = require('bootstrap/js/dist/modal');
    require('@popperjs/core');
    window.Popover = require('bootstrap/js/dist/popover');
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
      return new Popover(popoverTriggerEl)
    });

    //require('waypoints/lib/noframework.waypoints.js');



} catch (e) {}
